import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import RetractablePanel from 'components/RetractablePanel'
import Button from  'components/Button'

import { vehicleChanged } from 'scenes/VehicleDetail/actions'
import { edittingDocumentsChanged } from 'scenes/VehicleDetail/components/Data/actions'

import EditForm from './EditForm'

import './styles.scss'


export class Documents extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      vehicle: []
    }

    this._bind( '_renderHeaderActions', '_renderDocumentList', '_onEdit',
                '_renderDocument')
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.props.edittingDocumentsChanged(true)
  }

  _renderHeaderActions() {
    return !this.props.edittingDocuments ? (
      <div className="header-icons">
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : null
  }

  _renderDocument(document, index) {
    return (
      <div key={index} className="Documents__downloads d-flex flex-column">
        <span className="download_name">{document.type}</span>
        <Button icon="file_download" size="small" onClick={() => window.open(document.file)}>Descargar archivo</Button>
      </div>
    )
  }

  _renderDocumentList() {
    return (
      <div className="Documents__data d-flex justify-content-around align-items-center">
        {
          !!this.props.documents.length ?
            this.props.documents.map(this._renderDocument) :
            <p>No hay documentos</p>
        }
      </div>
    )
  }

  render() {
    return (
      <RetractablePanel
        ref={(panel) => this.panel = panel}
        name="Documentos"
        actionButtons={this._renderHeaderActions()}
        isToggle={false}
      >
        {this.props.edittingDocuments ? (
          <EditForm userId={this.props.userId } vehicleId={this.props.vehicleId} />) : (this._renderDocumentList()) }
      </RetractablePanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    edittingDocuments: state.dataVehicleDetail.get('edittingDocuments'),
    documents: state.vehicleDetail.get('documents')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    vehicleChanged: (vehicle) => dispatch(vehicleChanged(vehicle)),
    edittingDocumentsChanged: (edittingDocuments) => dispatch(edittingDocumentsChanged(edittingDocuments))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documents)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/Documents/index.js